import { ImprovementDriversModalTabID } from 'frontcore/presentation/improvement-drivers/domain/types'
import { ImprovementDriversTabID } from 'frontend/presentation/improvement-drivers-tabs/domain/types'
import { TAB_DICTIONARY, TOOLS_TAB_DICTIONARY } from 'frontend/presentation/sfm/domain/types'

export const TAB_ACTION_ID = 0
export const TAB_ALERT_ID = 1
export const TAB_IDEA_ID = 2
export const TAB_PROBLEM_ID = 3
export const TAB_RISK_ID = 4

export const TAB_EVIDENCE_ID = 10
export const TAB_COMMENT_ID = 11

export const TAB_KPI_CARD_DETAILS_ID = 20

export const SHOP_FLOOR_MANAGEMENT_SOURCE = 'ShopFloorManagement'
export const LINE_BOARD_SOURCE = 'LineBoard'

const TAB_ACTION_ROUTENAME = 'actions-list'
export const TAB_IMPROVEMENT_IDEAS_ROUTENAME = 'improvement-ideas-list'
const TAB_PROBLEM_ROUTENAME = 'problem-solving-list'

export const ISOLATED_ASSESSMENTS_ROUTE = 'sfm/isolated-assessments'

export const TABS_DICTIONARY: TAB_DICTIONARY[] = [
  {
    id: ImprovementDriversModalTabID.Action,
    routeName: TAB_ACTION_ROUTENAME,
    emptyMessage: 'sfm.messages.today_empty_actions',
  },
  {
    id: ImprovementDriversModalTabID.Idea,
    routeName: TAB_IMPROVEMENT_IDEAS_ROUTENAME,
    emptyMessage: 'sfm.messages.today_empty_improvement_ideas',
  },
  {
    id: ImprovementDriversModalTabID.Problem,
    routeName: TAB_PROBLEM_ROUTENAME,
    emptyMessage: 'sfm.messages.today_empty_problems',
  },
]

export type SFM_DASHBOARD_VIEW_TYPE_OPTIONS_TYPE = {
  single: {
    value: number,
    token: string,
  },
  aggregated: {
    value: number,
    token: string,
  },
}

export type SFM_DASHBOARD_FUNCTION_OPTIONS_TYPE = {
  sum: {
    value: number,
    token: string,
  },
  average: {
    value: number,
    token: string,
  },
}

export const SFM_DASHBOARD_VIEW_TYPE_OPTIONS: SFM_DASHBOARD_VIEW_TYPE_OPTIONS_TYPE = Object.freeze({
  single: {
    value: 0,
    token: 'gemba_walk.messages.single_data',
  },
  aggregated: {
    value: 1,
    token: 'gemba_walk.messages.aggregated_data',
  },
})

export const SFM_DASHBOARD_FUNCTION_OPTIONS: SFM_DASHBOARD_FUNCTION_OPTIONS_TYPE = Object.freeze({
  sum: {
    value: 0,
    token: 'common.messages.sum',
  },
  average: {
    value: 1,
    token: 'common.messages.avg_title',
  },
})

export const TAB_NOTE_ID = 1
export const TAB_NOTICE_ID = 2

const TAB_NOTE_ROUTENAME = 'notes-list'
const TAB_NOTICE_ROUTENAME = 'notices-list'

export const COMMUNICATIONS_TABS_DICTIONARY: TAB_DICTIONARY[] = [
  {
    id: TAB_NOTE_ID,
    routeName: TAB_NOTE_ROUTENAME,
    emptyMessage: 'common.messages.add_first_note',
  },
  {
    id: TAB_NOTICE_ID,
    routeName: TAB_NOTICE_ROUTENAME,
    emptyMessage: 'common.messages.add_first_notice',
  },
]

export const TOOLS_TABS_DICTIONARY: TOOLS_TAB_DICTIONARY[] = [
  {
    tabId: TAB_KPI_CARD_DETAILS_ID,
    driverTabID: ImprovementDriversTabID.Detail,
    dataTest: 'improvement-tool-tab-details',
  },
  {
    tabId: TAB_ACTION_ID,
    driverTabID: ImprovementDriversTabID.Action,
    dataTest: 'improvement-tool-tab-action',
    
  },
  {
    tabId: TAB_IDEA_ID,
    driverTabID: ImprovementDriversTabID.ImprovementIdea,
    dataTest: 'improvement-tool-tab-ideas',
  },
  {
    tabId: TAB_EVIDENCE_ID,
    driverTabID: ImprovementDriversTabID.Evidence,
    dataTest: 'improvement-tool-tab-evidence',
  },
  {
    tabId: TAB_COMMENT_ID,
    driverTabID: ImprovementDriversTabID.Comment,
    dataTest: 'improvement-tool-tab-comment',
  },
]

export type CommentCreatePayload = {
  created_by: number
  description: string
  kpi_card: number | undefined
  perimeter: number | undefined
}
